"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var themes_1 = require("./themes");

exports.Footer = styled_1.default.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 20px;\n  color: #fff;\n  background-color: #0f2d4c;\n  min-height: 20vh;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  padding-top: 20px;\n  color: #fff;\n  background-color: #0f2d4c;\n  min-height: 20vh;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.footer) === null || _c === void 0 ? void 0 : _c.boxShadow, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.footer.boxShadow;
}, function (_a) {
  var theme = _a.theme,
      backgroundColor = _a.backgroundColor;

  var _b, _c, _d;

  return backgroundColor || (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.footer) === null || _c === void 0 ? void 0 : _c.background, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.footer.background);
}, function (_a) {
  var theme = _a.theme,
      color = _a.color;

  var _b, _c, _d;

  return color || (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.footer) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.footer.color);
});
exports.FooterIcon = styled_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 16px;\n  margin-right: 10px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  margin-right: 10px;\n"])));
exports.FooterField = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 10px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 10px;\n"])));
exports.FooterList = styled_1.default.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin-top: 0;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin-top: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;